import capitalize from './legoCapitalize.js';
import formattedDate from './legoFormattedDate';

export default {
  install: (Vue) => {
    Vue.config.globalProperties.$filters = {
      ...Vue.config.globalProperties.$filters,
      capitalize,
      formattedDate
    }
  },
};
